export default __webpack_public_path__ + "static/media/bg-bottom.f94fdf11.png";